import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";

const ApproveAccountManagerModal = ({
  show,
  handleClose,
  handleConfirm,
  message,
  transactionAccountNumber,
  setTransactionAccountNumber,
  transactionRefNo,
  setTransactionRefNo,
  transactionDate,
  setTransactionDate,
  transactionAmount,
  setTransactionAmount,
  proposedLoanAmount,
  sanctionedLoanAmount,
  processingCharge,
  isProcessingChargePaid,
  gst,
  isGstPaid,
  securityDeposit,
  isSecurityDepositPaid,
  isLoanInsured,
  insuranceAmount,
  isInsuranceAmountPaid,
  amountToRelease,
  loanType,
  ornamentModelNoByBm,
  setOrnamentModelNoByBm,
  ornamentNameByBm,
  setOrnamentNameByBm,
  ornamentWeightByBm,
  setOrnamentWeightByBm,
  wastageByBm,
  setWastageByBm,
  gstByBm,
  setGstByBm,
  goldRateByBm,
  setGoldRateByBm,
  ornamentWeightValueByBm,
  wastageValueByBm,
  totalByBm,
  gstValueByBm,
  eligibleLoanAmountByBm,
  totalLoanAmountByBm,
}) => {
  const [validationError, setValidationError] = useState("");

  const handleClick = () => {
    // Note on the amount check: do NOT use !transactionAmount, because !0 is true and
    // zero is a legitimate value here (most existing Business Loan records store 0).
    // Only an empty field or a negative number is rejected.
    const amountIsEmpty =
      transactionAmount === "" ||
      transactionAmount === null ||
      transactionAmount === undefined;
    const amountIsNegative = !amountIsEmpty && Number(transactionAmount) < 0;

    if (
      (loanType === "Business Loan" || loanType === "Daily Loan") &&
      (!transactionAccountNumber ||
        !transactionRefNo ||
        !transactionDate ||
        amountIsEmpty)
    ) {
      setValidationError("Please fill all fields");
    } else if (amountIsNegative) {
      setValidationError("Transaction amount cannot be a negative value");
    } else {
      setValidationError("");
      handleConfirm();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>{message}</h6>
        <div className="my-3">
          {loanType === "Business Loan" && (
            <>
              <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
              <p>Sanctioned Loan Amount : Rs.{sanctionedLoanAmount}</p>
              <p>Processing Charge : Rs.{processingCharge}</p>
              <p>GST Amount : Rs.{gst}</p>
              <p>Security Deposit : Rs.{securityDeposit}</p>
              <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
              {isLoanInsured && (
                <>
                  <p>Insurance Amount : Rs.{insuranceAmount}</p>
                </>
              )}
              <p>Loan Amount to Release : Rs.{amountToRelease}</p>
              <Form.Group>
                <Form.Label>Bank Account Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Bank Account Number"
                  value={transactionAccountNumber}
                  onChange={(event) => {
                    setTransactionAccountNumber(event.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Ref No</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Transaction Ref No"
                  value={transactionRefNo}
                  onChange={(event) => {
                    setTransactionRefNo(event.target.value);
                  }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Amount</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter Transaction Amount"
                  value={transactionAmount}
                  onChange={(event) => {
                    // Ignore anything that parses below zero. Also covers paste,
                    // which onKeyDown alone would not catch.
                    const val = event.target.value;
                    if (val === "" || Number(val) >= 0) {
                      setTransactionAmount(val);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                    // Block the minus/plus/exponent keys outright
                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date"
                  value={transactionDate}
                  onChange={(event) => setTransactionDate(event.target.value)}
                />
              </Form.Group>
            </>
          )}
          {loanType === "Daily Loan" && (
            <>
              <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
              <p>Sanctioned Loan Amount : Rs.{sanctionedLoanAmount}</p>
              <p>Processing Charge : Rs.{processingCharge}</p>
              <p>GST Amount : Rs.{gst}</p>
              <p>Security Deposit : Rs.{securityDeposit}</p>
              <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
              {isLoanInsured && (
                <>
                  <p>Insurance Amount : Rs.{insuranceAmount}</p>
                </>
              )}
              <p>Loan Amount to Release : Rs.{amountToRelease}</p>
              <Form.Group>
                <Form.Label>Bank Account Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Bank Account Number"
                  value={transactionAccountNumber}
                  onChange={(event) => {
                    setTransactionAccountNumber(event.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Ref No</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Transaction Ref No"
                  value={transactionRefNo}
                  onChange={(event) => {
                    setTransactionRefNo(event.target.value);
                  }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Amount</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter Transaction Amount"
                  value={transactionAmount}
                  onChange={(event) => {
                    // Ignore anything that parses below zero. Also covers paste,
                    // which onKeyDown alone would not catch.
                    const val = event.target.value;
                    if (val === "" || Number(val) >= 0) {
                      setTransactionAmount(val);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                    // Block the minus/plus/exponent keys outright
                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date"
                  value={transactionDate}
                  onChange={(event) => setTransactionDate(event.target.value)}
                />
              </Form.Group>
            </>
          )}
          {loanType === "GP Loan" && (
            <>
              <p>Proposed Loan Amount : Rs.{proposedLoanAmount}</p>
              <p>Gold Rate : Rs.{goldRateByBm}</p>
              <p>Ornament Model No : {ornamentModelNoByBm}</p>
              <p>Ornament Name : {ornamentNameByBm}</p>
              <p>Ornament Weight : {ornamentWeightByBm}</p>
              <p>Ornament Weight Value :Rs.{ornamentWeightValueByBm}</p>
              <p>Wastage : {wastageByBm}</p>
              <p>Wastage Value : Rs.{wastageValueByBm}</p>
              <p>GST : {gstByBm}</p>
              <p>GST Value : {gstValueByBm}</p>
              <p>Eligible Loan Amount : Rs.{eligibleLoanAmountByBm}</p>
              <p>Processing Charge : Rs.{processingCharge}</p>
              <p>GST Amount : Rs.{gst}</p>
              <p>Loan Insured? : {isLoanInsured ? "Yes" : "No"}</p>
              {isLoanInsured && (
                <>
                  <p>Insurance Amount : Rs.{insuranceAmount}</p>
                </>
              )}
              {/* <p>Total Loan Amount : {totalLoanAmountByBm}</p> */}
              <Form.Group>
                <Form.Label>Bank Account Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Bank Account Number"
                  value={transactionAccountNumber}
                  onChange={(event) => {
                    setTransactionAccountNumber(event.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Amount</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  placeholder="Enter Transaction Amount"
                  value={transactionAmount}
                  onChange={(event) => {
                    // Ignore anything that parses below zero. Also covers paste,
                    // which onKeyDown alone would not catch.
                    const val = event.target.value;
                    if (val === "" || Number(val) >= 0) {
                      setTransactionAmount(val);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                    // Block the minus/plus/exponent keys outright
                    if (e.key === "-" || e.key === "+" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.preventDefault()}
                  onFocus={(e) => {
                    e.target.addEventListener(
                      "wheel",
                      (e) => e.preventDefault(),
                      {
                        passive: false,
                      }
                    );
                  }}
                  onBlur={(e) => {
                    e.target.removeEventListener("wheel", (e) =>
                      e.preventDefault()
                    );
                  }}
                  step="1"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Transaction Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date"
                  value={transactionDate}
                  onChange={(event) => setTransactionDate(event.target.value)}
                />
              </Form.Group>
            </>
          )}
          <p className="text-danger">{validationError}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleClick}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApproveAccountManagerModal;
